import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('empathiq_token');
        const savedUser = localStorage.getItem('empathiq_user');
        
        if (token && savedUser) {
            try {
                setUser(JSON.parse(savedUser));
            } catch (e) {
                localStorage.removeItem('empathiq_token');
                localStorage.removeItem('empathiq_user');
            }
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        const response = await authAPI.login({ email, password });
        const { access_token, user: userData } = response.data;
        
        localStorage.setItem('empathiq_token', access_token);
        localStorage.setItem('empathiq_user', JSON.stringify(userData));
        setUser(userData);
        
        return userData;
    };

    const register = async (name, email, password, role = 'employee', organizationName = null) => {
        const payload = { name, email, password, role };
        if (organizationName) {
            payload.organization_name = organizationName;
        }
        const response = await authAPI.register(payload);
        const { access_token, user: userData } = response.data;
        
        localStorage.setItem('empathiq_token', access_token);
        localStorage.setItem('empathiq_user', JSON.stringify(userData));
        setUser(userData);
        
        return userData;
    };

    const logout = () => {
        localStorage.removeItem('empathiq_token');
        localStorage.removeItem('empathiq_user');
        setUser(null);
    };

    const isHR = () => user?.role === 'hr' || user?.role === 'admin';

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, isHR }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
